import { create } from "zustand";
import { axiosInstancev1 } from "../../lib/axiosInstance";
import { toast } from "react-hot-toast";
import useAuthStore from "../useAuthStore";

const useSubscriptionStore = create((set) => ({
    history: [],
    isLoadingHistory: false,
    errorHistory: null,

    fetchSubscriptionHistory: async () => {
        set({ isLoadingHistory: true, errorHistory: null });

        const { token, user } = useAuthStore.getState();

        // LIVE FIX : Extract correct builder ID
        const builderId =
            user?.builder_profile_id ||
            user?.builderId ||
            user?.id ||
            null;

        if (!token || !builderId) {
            toast.error("Authentication required to fetch history.");
            set({ isLoadingHistory: false, errorHistory: "Not authenticated" });
            return;
        }

        try {
            const response = await axiosInstancev1.get(
                "/subscriptions/builder/history",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "x-builder-id": builderId, // 🔥 REQUIRED LIVE FIX
                    }
                }
            );

            if (response.data.success) {
                // Filter to show only active subscriptions
                const allHistory = response.data.history || [];
                const activeHistory = allHistory.filter(
                    (transaction) => transaction.status?.toLowerCase() === 'active'
                );
                
                set({
                    history: activeHistory,
                    isLoadingHistory: false
                });
            } else {
                throw new Error(response.data.message || "Failed to fetch subscription history.");
            }
        } catch (error) {
            const errorMsg =
                error.response?.data?.message ||
                "Could not fetch subscription history.";

            toast.error(errorMsg);

            set({
                isLoadingHistory: false,
                errorHistory: errorMsg,
                history: []
            });
        }
    },
}));

export default useSubscriptionStore;
